import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';
import type { TCustomerUpdateData, TCustomerUpdateDataResponse } from 'shared/types/TCustomerService';

// TODO перенести в доменную область entities/creditForm/model/creditForm.query.ts для реализации
// matchPending → isLoading = true
// matchFulfilled → false
// matchRejected → false
export const sendCustomerDataApi = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    updateCustomerData: build.mutation<TCustomerUpdateDataResponse, TCustomerUpdateData>({
      query: (query) => ({
        url: BFF_API_ROUTES.updateUserData,
        method: 'POST',
        body: query,
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});
